import { render, staticRenderFns } from "./reparar.vue?vue&type=template&id=a9d951f2"
import script from "./reparar.vue?vue&type=script&lang=js"
export * from "./reparar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports